import { Instagram, Facebook, Linkedin, Phone } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-charcoal py-16" data-testid="footer-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {/* Logo & Description */}
          <div>
            <button
              onClick={() => scrollToSection('#hero')}
              className="font-serif text-3xl text-cream bg-transparent border-none cursor-pointer text-left"
            >
              Alita Captures
            </button>
            <p className="font-body text-stone mt-4 leading-relaxed">
              Capturing moments that matter. Photography & videography services across Canada.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-sans text-xs tracking-widest text-cream mb-6">
              QUICK LINKS
            </h4>
            <nav className="flex flex-col gap-3">
              {[
                { href: '#services', label: 'Services' },
                { href: '#portfolio', label: 'Portfolio' },
                { href: '#about', label: 'About' },
                { href: '#contact', label: 'Contact' },
              ].map((link) => (
                <button
                  key={link.href}
                  onClick={() => scrollToSection(link.href)}
                  className="font-body text-stone hover:text-cream transition-colors text-left bg-transparent border-none cursor-pointer"
                  data-testid={`footer-${link.label.toLowerCase()}`}
                >
                  {link.label}
                </button>
              ))}
            </nav>
          </div>

          {/* Contact & Social */}
          <div>
            <h4 className="font-sans text-xs tracking-widest text-cream mb-6">
              CONTACT US
            </h4>
            <div className="space-y-4 mb-6">
              <a
                href="mailto:labadysterley@gmail.com"
                className="font-body text-stone hover:text-cream transition-colors block"
              >
                labadysterley@gmail.com
              </a>
              <a
                href="tel:+12088030470"
                className="font-body text-stone hover:text-cream transition-colors flex items-center gap-2"
              >
                <Phone size={16} />
                +1 (208) 803-0470
              </a>
            </div>
            
            <h4 className="font-sans text-xs tracking-widest text-cream mb-4 mt-8">
              FOLLOW US
            </h4>
            <div className="flex gap-4">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="p-3 border border-sand/30 text-cream hover:border-terracotta hover:text-terracotta transition-colors"
                data-testid="footer-instagram"
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="p-3 border border-sand/30 text-cream hover:border-terracotta hover:text-terracotta transition-colors"
                data-testid="footer-facebook"
                aria-label="Facebook"
              >
                <Facebook size={20} />
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="p-3 border border-sand/30 text-cream hover:border-terracotta hover:text-terracotta transition-colors"
                data-testid="footer-linkedin"
                aria-label="LinkedIn"
              >
                <Linkedin size={20} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-sand/20 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="font-sans text-xs tracking-widest text-stone">
            © {currentYear} ALITA CAPTURES. ALL RIGHTS RESERVED.
          </p>
          <p className="font-body text-sm text-stone">
            Montreal & Toronto, Canada
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
